import {DateObject} from "react-multi-date-picker";

const useQueryString = () => {

  const buildQuery = (params) =>
    Object.entries(params)
      .map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&')

  const update = (queryKey, queryValue) => {
    let params = parseCurrentParams()

    if (queryKey === 'where') {
      if (queryValue) { // alleen als object
        if (queryValue.city) params['where.city'] = queryValue.city
        if (queryValue.postal_code) params['where.postal_code'] = queryValue.postal_code
        if (queryValue.radius) params['where.radius'] = queryValue.radius
      } else {
        delete params['where.city']
        delete params['where.postal_code']
        delete params['where.radius']
      }
    } else if (queryKey === 'map') {
      // Map object niet in URL zetten - wordt alleen intern gebruikt
      // en veroorzaakt [object Object] bug
      delete params['map']
    } else {
      if (
        queryValue === null ||
        queryValue === undefined ||
        queryValue === '' ||
        (Array.isArray(queryValue) && queryValue.length === 0)
      ) {
        delete params[queryKey]
      } else if (typeof queryValue === 'object' && !Array.isArray(queryValue)) {
        // Objecten niet direct in URL zetten - voorkomt [object Object]
        // Als het object in de URL moet, moet het expliciet gehandeld worden (zoals 'where')
        delete params[queryKey]
      } else {
        params[queryKey] = queryValue
      }
    }


    const newUrl = [window.location.pathname, buildQuery(params)]
      .filter(Boolean)
      .join('?')

    window.history.replaceState(null, '', newUrl)
  }

  const getUrl = (filter) => {
    const params = {}
    Object.entries(filter).forEach(([key, value]) => {
      // Skip map object - cannot be serialized
      if (key === 'map') {
        return
      }
      // Skip types=0 and industries=0 - these represent "no filter"
      if (key === 'types' || key === 'industries') {
        // eslint-disable-next-line eqeqeq
        if (value == 0 ||
            (Array.isArray(value) && value.length === 0) ||
            (Array.isArray(value) && value.length === 1 && value[0] == 0)) {
          return
        }
      }
      // Handle where object specially - serialize as where.city, where.radius, etc.
      if (key === 'where' && value && typeof value === 'object') {
        if (value.city) params['where.city'] = value.city
        if (value.postal_code) params['where.postal_code'] = value.postal_code
        if (value.radius) params['where.radius'] = value.radius
        return
      }
      if (Array.isArray(value) && value[0] instanceof DateObject) {
        params[key] = value.map(date => date.format("YYYY-M-D").toString()).join('_')
      } else if (Array.isArray(value)) {
        params[key] = value.join('_')
      } else if (value && typeof value !== 'object') {
        params[key] = value
      }
    })
    return buildQuery(params)
  }

  const getAll = () => {
    const query = window.location.search.replace(/^\?/, '')
    const pairs = query.split('&').filter(Boolean)
    const array = []
    for (const pair of pairs) {
      const [rawKey, rawValue] = pair.split('=')
      let key = decodeURIComponent(rawKey)
      let value = decodeURIComponent(rawValue || '')

      if (key === 'types' || key === 'industries') {
        value = value.split('_').map(Number)
      }
      if (key === 'when') {
        const dates = value.split(/[_ ,]+/) // split op underscore of komma of spatie
        value = dates.map(dateString => new DateObject(dateString))
      }
      if (key !== 'map') {
        array.push({key, value})
      }
    }
    return array
  }

  const parseCurrentParams = () => {
    const query = window.location.search.replace(/^\?/, '')
    const pairs = query.split('&').filter(Boolean)
    const params = {}
    for (const pair of pairs) {
      const [rawKey, rawValue] = pair.split('=')
      params[decodeURIComponent(rawKey)] = decodeURIComponent(rawValue || '')
    }
    return params
  }

  return { update, getAll, getUrl }
}

export default useQueryString
